import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

import { stepTypes, stepTypesLabels } from '../../../constants/compound';
import ClosingRangePicker from '../../common/ClosingRangePicker';
import CompoundOptionsContainer from '../../compound/OptionsContainer';
import StepHeader from '../../funnel/update/StepHeader';

const { Option } = Select;

const StyledMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px 10px;
  flex: 1;
  width: 100%;

  .closing-range-picker-container {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  .segment-update-step-filter-container {
    border-top: 1px solid #d9d9d9;
    margin-top: 8px;
    padding-top: 8px;
  }
`;

const StyledSelect = styled(Select)`
  width: 240px;
`;

const prepareStepTypeChosen = (setStepType, stepType) => (
  <StyledSelect
    dropdownMatchSelectWidth={false}
    dropdownStyle={{ width: 'auto' }}
    value={stepType || undefined}
    onSelect={(t) => setStepType(t)}
    className="ant-select-border-bottom"
  >
    <Option value={stepTypes.POSITIVE}>{stepTypesLabels.POSITIVE}</Option>
    <Option value={stepTypes.LOCAL_NEGATIVE}>{stepTypesLabels.LOCAL_NEGATIVE}</Option>
  </StyledSelect>
);

const getLabel = (first, setStepType, stepType) =>
  first ? (
    <div className="disable-select">Users who did the event</div>
  ) : (
    prepareStepTypeChosen(setStepType, stepType)
  );

const CompoundUpdateStep = ({
  removeStep,
  setEventName,
  setClosingRange,
  setStepType,
  setStepCount,
  renderStepFilter,
  events,
  event,
  closingRange,
  filter,
  stepIndex,
  stepType,
  count,
  countOperator,
  showNotValidFields,
  first,
}) => {
  return (
    <>
      <StyledMainContainer>
        <StepHeader
          event={event}
          events={events}
          first={first}
          removeStep={removeStep}
          setEventName={setEventName}
          showNotValidFields={showNotValidFields}
          label={getLabel(first, setStepType, stepType)}
          enabled
        />
        {!first ? (
          <div className="closing-range-picker-container">
            <ClosingRangePicker
              closingRange={closingRange}
              onChange={(cr) => setClosingRange(cr)}
              selectClassName="ant-select-border-bottom"
              inputClassName="ant-input-border-bottom"
            />
          </div>
        ) : null}
        <div className="segment-update-step-filter-container">
          {renderStepFilter({ stepIndex, event, filter })}
        </div>
      </StyledMainContainer>
      <CompoundOptionsContainer
        showCount
        count={count}
        countOperator={countOperator}
        onCountChange={(countParam, operator) => setStepCount(countParam, operator)}
      />
    </>
  );
};

export default CompoundUpdateStep;
